import React, { useRef } from 'react';
import './ConsultantPayment.sass';
import { ReactComponent as Padlock } from '../static/img/padlock.svg';
import { ReactComponent as Info } from '../static/img/info.svg';
import Modal from '../components/Modal';

export default function ConsultantPayment({ state }) {
  const showPaymentAuthInfoRef = useRef();

  const handleShowPaymentAuthInfo = event => {
    event.preventDefault();
    showPaymentAuthInfoRef.current.show();
  };

  const isInsurance = state.formValues?.payment?.toLowerCase() === 'insurance';

  const mandatoryPaymentHospitals = process.env.REACT_APP_MANDATORY_PAYMENT.split(',');
  const mandatoryPayment = mandatoryPaymentHospitals.includes(state.hospital.hospitalId);

  const paymentAuthorisationText = () => {
    return isInsurance ? (
      mandatoryPayment ? (
        <p className="consultant-payment__authorisation-content-text">
          We will take payment card details to authorise your card securely and to make paying for
          any hospital costs that your insurance doesn’t cover as smooth and safe as possible.{' '}
          <span className="bold">You won’t be charged until after your treatment</span> and will be
          notified with an invoice outlining your charges.
        </p>
      ) : (
        <p className="consultant-payment__authorisation-content-text">
          To save time after your treatment and securely authorise your payment method for any
          hospital costs your insurance doesn’t cover,{' '}
          <span className="bold">you can enter your payment card details now</span> to make paying
          as smooth and safe as possible.{' '}
          <span className="bold">You won’t be charged until after your treatment</span> and will
          receive an invoice outlining your charges.
        </p>
      )
    ) : mandatoryPayment ? (
      <p className="consultant-payment__authorisation-content-text">
        We will take payment card details to authorise your card securely and to make paying for any
        hospital costs as smooth and safe as possible.{' '}
        <span className="bold">You won’t be charged until after your treatment</span> and will be
        notified with an invoice outlining your charges.
      </p>
    ) : (
      <p className="consultant-payment__authorisation-content-text">
        To save time after your treatment and securely authorise your payment method for any
        hospital charges, <span className="bold">you can enter your payment card details now</span>.
        You won’t be charged until after your treatment and will be notified with an invoice
        outlining your charges.
      </p>
    );
  };

  return (
    <>
      <div className="consultant-payment">
        <div className="consultant-payment__heading">
          <div className="consultant-payment__heading-icon">
            <Padlock />
          </div>
          <h4>Payment authorisation *</h4>
        </div>
        <div className="consultant-payment__authorisation-content">
          {paymentAuthorisationText()}
          <button
            className="consultant-payment__info-icon-btn"
            onClick={event => handleShowPaymentAuthInfo(event)}
          >
            <Info />
          </button>
        </div>

        <Modal type="paymentAuthInfo" ref={showPaymentAuthInfoRef}>
          {() => (
            <div className="consultant-payment__modal-text">
              <p className="consultant-payment__modal-text--title">Payment authorisation</p>
              <div className="consultant-payment__modal-text--list">
                <ul>
                  <li>
                    It is Nuffield Health’s policy to collect payment card details as part of the
                    booking process or at your initial hospital visit regardless of whether you are
                    paying for yourself or using private health insurance.
                  </li>
                  <li>
                    Your credit/debit card details will only be used to secure payment in the
                    circumstances described in{' '}
                    <a
                      className="link bold"
                      target="_blank"
                      rel="noreferrer noopener"
                      href="https://www.nuffieldhealth.com/terms/nuffield-health-website-terms-and-conditions"
                    >
                      our T&Cs.
                    </a>
                  </li>

                  {isInsurance ? (
                    <>
                      <li>Speak to your chosen insurer for details on what to do next.</li>
                      <li>
                        You will receive an invoice after your appointments and treatment for
                        anything your insurer doesn’t cover.
                      </li>
                    </>
                  ) : (
                    <>
                      <li>
                        Separate charges will be invoiced to you by your consultant, these will be
                        billed separately to your Nuffield Health hospital invoice. If you have any
                        queries about this, please contact the hospital prior to your appointment.
                      </li>
                    </>
                  )}

                  <li>
                    For peace of mind, if you incur any charges these will be detailed on an invoice
                    which will be provided before any payment is taken.
                  </li>
                </ul>
              </div>

              <p className="consultant-payment__modal-text--info">
                For more information about our payment authorisation process,{' '}
                <a
                  className="link bold"
                  target="_blank"
                  rel="noreferrer noopener"
                  href="https://www.nuffieldhealth.com/hospitals/patient-information/payments-authorisations-by-credit-debit-card"
                >
                  check our frequently asked questions here.
                </a>
              </p>
              <div className="consultant-payment__btn-container">
                <button
                  aria-label="Close modal"
                  className="primary-btn consultant-payment__close-btn"
                  onClick={() => showPaymentAuthInfoRef.current.hide()}
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </Modal>
      </div>
    </>
  );
}
